"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var header = function header(theme) {
  return /*#__PURE__*/(0, _react.css)("width:100%;display:flex;align-items:center;text-align:left;cursor:pointer;svg{color:", theme.color.monochrome.mediumDark, ";}&:hover{svg{color:", theme.color.primary.brand, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:header;"));
};

var avatar = /*#__PURE__*/(0, _react.css)("width:", (0, _util.rem)(32), ";height:", (0, _util.rem)(32), ";border-radius:", (0, _util.rem)(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:avatar;"));
var menu = /*#__PURE__*/(0, _react.css)("&>li{padding-top:", (0, _util.rem)(12), ";padding-bottom:", (0, _util.rem)(12), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:menu;"));
var footer = /*#__PURE__*/(0, _react.css)("display:flex;align-items:center;svg{transform:rotate(-90deg);margin-right:", (0, _util.rem)(4), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:footer;"));
var styles = {
  header: header,
  avatar: avatar,
  menu: menu,
  footer: footer
};
exports.styles = styles;
//# sourceMappingURL=UserSettings.styles.js.map